<template>
  <yxt-table ref="multipleTable"
             v-loading="isLoading"
             :data="list"
             class="clazz_width_100"
             :default-sort="{ prop: 'createTime', order: 'descending' }"
             @sort-change="sortChange"
             @selection-change="handleSelectionChange">
    <yxt-table-column
      v-if="selectable"
      :show-overflow-tooltip="false"
      type="selection"
      width="38"
      align="right"
      clear-padding="left-right" />
    <yxt-table-column
      v-for="item in columnConfigs"
      :key="item.prop"
      :label="item.label"
      :prop="item.prop"
      :show-overflow-tooltip="item.showTooltip"
      :width="item.width"
      :min-width="item.minWidth"
      :clear-padding="item.clearPadding"
      :popover-html="item.popoverHtml"
    >
      <template v-if="hasSlot('header')" v-slot:header>
        <slot name="header" :config="item"></slot>
      </template>
      <template v-if="item.type!='selection'" slot-scope="scope">
        <slot v-if="hasSlot(item.prop)"
              :name="item.prop"
              :config="item"
              :data="scope.row">
          <span>{{ cellShow(item,scope.row) }}</span>
        </slot>
        <span v-else>{{ cellShow(item,scope.row) }}</span>
      </template>
    </yxt-table-column>
    <!-- 操作 -->
    <yxt-table-column v-if="tableOperation&&tableOperation.length"
                      :label="$t('pc_biz_ote_btn_operate')"
                      width="80"
                      fixed="right">
      <template slot-scope="scope">
        <yxt-button v-for="item in tableOperation"
                    :key="item.label"
                    :disabled="actionDisabled(item.disabled)"
                    type="text"
                    @click="item.action(scope.row)">
          {{ item.label }}
        </yxt-button>
      </template>
    </yxt-table-column>
    <yxt-empty v-if="tableData.length === 0" slot="empty"/>
  </yxt-table>
</template>

<script>
export default {
  name: 'CommonTable',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => []
    },
    defaultSort: {
      type: Object,
      default: () => ({})
    },
    selectable: {
      type: Boolean,
      default: false
    },
    columnConfigs: {
      type: Array,
      default: () => []
    },
    tableOperation: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    list() {
      return this.tableData;
    },
    isLoading() {
      return this.loading;
    }
  },
  methods: {
    sortChange() {
    },
    handleSelectionChange(val) {
      this.$emit('update:selected', val);
    },
    cellShow(config, data) {
      return data[config.prop] || '--';
    },
    actionDisabled(obj) {
      if (typeof obj === 'function') {
        return obj();
      }
      return obj;
    },
    hasSlot(name) {
      return !!this.$scopedSlots[name];
    }
  }
};
</script>
